import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { getStatus } from './helpers';
import { useDocumentState } from '../../../contexts/DocumentContext';
import { DocumentBadge } from '../document-badge/DocumentBadge';
import { getDocumentStatusIndicator } from '../../document-table/helpers/documentStatusIndication';
import { DocumentStatusEnum } from '../../../shared/constants/document';

export const DocumentBadgeContainer = () => {
  const { state } = useDocumentState();
  const receiverTeamId = state.receiverTeamId;
  const documentStatus = state.status;
  const hasCurrentTeamPossession = state.currentTeamPossession;
  const badgeStatusIndicator = getDocumentStatusIndicator(
    (documentStatus as DocumentStatusEnum) || DocumentStatusEnum.DRAFT,
    hasCurrentTeamPossession
  );

  const [currentStatus, setCurrentStatusMessage] = useState<DocumentStatusEnum | null>(null);

  let isShared = !!receiverTeamId;

  useEffect(() => {
    setCurrentStatusMessage(getStatus(documentStatus));
  }, [receiverTeamId, documentStatus, isShared]);

  return (
    <DocumentBadge documentStatus={currentStatus || DocumentStatusEnum.DRAFT}>
      {currentStatus && (
        <FormattedMessage
          id={`lease-document-wizard.badge.${currentStatus}-offer`}
          defaultMessage={badgeStatusIndicator}
        />
      )}
    </DocumentBadge>
  );
};
